import { Component, OnInit } from '@angular/core';
import { PostService } from '../../Services/post.service'
import { GetService} from '../../Services/get.service'

import {ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { LoginService } from '../../Services/login.service'

import {AuthenticationDetails, CognitoUser, CognitoUserSession, CognitoUserAttribute, CognitoUserPool} from 'amazon-cognito-identity-js';

const PoolData = {
  UserPoolId: 'us-east-1_AF2OC889V',
  ClientId: 'umhuap3utcv5anus13nk2u8bp'
};

const userPool = new CognitoUserPool(PoolData);

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [LoginService]
})
export class LoginComponent implements OnInit {
  walkUser: user;
  selectableItems;
  constructor(private postService: PostService, private getService : GetService, private loginService : LoginService, private route: ActivatedRoute, private router: Router) {
    this.walkUser = {} as any;
  }
  status = "";
  showStatus = false;

  private subscriber: any;

  ngOnInit() {
    this.subscriber = this.route.queryParams.subscribe(params => {
      this.status = params['status'];
      if (this.status && this.status != "") {
        this.showStatus = true;
      }
  });
  }

  login() {
    console.log("Login");
    this.walkUser.instances = new Array();
    this.walkUser.instances.push(this.walkUser.instance);

    this.signinUser(this.walkUser.username, this.walkUser.password);

    this.walkUser = {} as any;
  }

  signinUser(username: string, password: string) {
    const authData = {
      Username: username,
      Password: password
    };
    const authDetails = new AuthenticationDetails(authData);
    const userData = {
      Username: username,
      Pool: userPool
    };
    const cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authDetails, {
      onSuccess: (result) => {
        const token = result.getIdToken().getJwtToken();
        console.log(result.getIdToken().getJwtToken());
        this.sucessfulLogin(cognitoUser, username, token);
      },
      onFailure: (err) => {
        console.log('There was an error during login, please try again -> ', err)
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        console.log("new password");
        cognitoUser.completeNewPasswordChallenge(password, {}, { 
          onSuccess: (session: CognitoUserSession) => {
            console.log(session.getAccessToken().getJwtToken())
            this.sucessfulLogin(cognitoUser, username, session.getIdToken().getJwtToken());
          },
          onFailure: (err) => { 

          }
        });
      }
    })
  }

  sucessfulLogin(cognitoUser: any, username: String, token: String) { 
    cognitoUser.getUserAttributes((err, result) => {
      if (err) {
          console.log(err);
          this.status = "Unable to retrieve attributes"; 
          this.showStatus = true;
          return;
      }
      let instance = '';
      for (let i = 0; i < result.length; i++) {
       if (result[i].getName() == 'custom:instance') { 
        instance = result[i].getValue();
       }
      }
      if (instance != '') { 
        this.loginService.setCredentials(username, instance, token);
        this.router.navigate(['family']);
      } else { 
        this.status = "No Instance Set, Cannot Log In"; 
        this.showStatus = true;
        return;
      }
   });
  }
}

interface user {
  username: string;
  password: string;
  instance: string;
  instances: Array<string>;
}



// WEBPACK FOOTER //
// ./src/app/Components/login/login.component.ts